import { TableCertification } from './components/TableCertification'

function App() {
  return (
    <TableCertification />
  );
}

export default App;
